import { render } from "./Login.vue?vue&type=template&id=b20c3c68&scoped=true&ts=true"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"

import "./Login.vue?vue&type=style&index=0&id=b20c3c68&scoped=true&lang=css"

import exportComponent from "D:\\Users\\Anton\\Workspaces\\htdocs\\ehop-admin-vueapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b20c3c68"]])

export default __exports__